export type CancellationReasonState = {
  cancellationType: string;
  cancellationCategory: string; // Also known as reason - outcome
  cancellationSubCategory: string; // Also known as reason - reason
  customerReturnDate: string;
  cancellationAddRestrictionToAccount: string;
  vehicleRemarketable: boolean | null;
  cancellationAdditionalInfo: string;
};

export type CancellationReasonAction =
  | { type: "SET_CANCELLATION_TYPE"; payload: string }
  | { type: "SET_CANCELLATION_CATEGORY"; payload: string }
  | { type: "SET_CANCELLATION_SUBCATEGORY"; payload: string }
  | { type: "SET_CUSTOMER_RETURN_DATE"; payload: string }
  | { type: "SET_ADD_RESTRICTION_TO_ACCOUNT"; payload: string }
  | { type: "SET_VEHICLE_REMARKETABLE"; payload: boolean | null}
  | { type: "SET_ADDITIONAL_INFO"; payload: string };

export const cancellationReasonInitialState: CancellationReasonState = {
  cancellationType: "",
  cancellationCategory: "",
  cancellationSubCategory: "",
  customerReturnDate: "",
  cancellationAddRestrictionToAccount: "",
  vehicleRemarketable: true,
  cancellationAdditionalInfo: "",
};

export function cancellationReasonReducer(state: CancellationReasonState, action: CancellationReasonAction): CancellationReasonState {
  switch (action.type) {
    case "SET_CANCELLATION_TYPE":
      return { ...state, cancellationType: action.payload };
    case "SET_CANCELLATION_CATEGORY":
      return { ...state, cancellationCategory: action.payload };
    case "SET_CANCELLATION_SUBCATEGORY":
      return { ...state, cancellationSubCategory: action.payload };
    case "SET_CUSTOMER_RETURN_DATE":
      return { ...state, customerReturnDate: action.payload };
    case "SET_ADD_RESTRICTION_TO_ACCOUNT":
      return { ...state, cancellationAddRestrictionToAccount: action.payload };
    case "SET_VEHICLE_REMARKETABLE":
      return { ...state, vehicleRemarketable: action.payload };
    case "SET_ADDITIONAL_INFO":
      return { ...state, cancellationAdditionalInfo: action.payload };
    default:
      console.log(`Error - incorrect action sent ${action} ${state}`)
      return state;
  }
}